import React, { useState, useEffect } from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";
import { withRouter } from 'react-router';

const MessagesSend = () => {
    const [showQTXSurvey, setShowQTXSurvey] = useState(false);
    const [childFrameData, setChildFrameData] = useState({});

    useEffect(() => {
        logUI("MBHWeb.UI.MessagesSend.ComponentDidMount", new Date(), Tools.getURLPath());
    }, []);
 
    useEffect(() => {
        console.info(`MessagesSend addQTXDiv`, childFrameData);
        if (window.serverData.data.enableQualtricsSurveySendMessage && childFrameData.event === "bswMatchedMutation" && childFrameData.data.type === "childList" && childFrameData.data.target === "div.Toast") {
            console.info(`MessagesSend addQTXDiv got the expected tag added`, childFrameData);
            setShowQTXSurvey(true);
        }
    }, [childFrameData, showQTXSurvey]);

    const heading = (
            <div className="row page-heading-container--dt">
                <div className="col-8 col-md-10">
                    <h1 className="page-heading dt-heading-line">Send a Message</h1>
                </div>
            </div>);
    return <MyChartContainer id="myChartContainer" showQTXSurvey={showQTXSurvey} bswMatch="div.Toast" observe="div#appRoot" onObserved={(messageEvent) => { setChildFrameData(messageEvent); } } mode="medadvice" title="Send a Message" heading={heading} />;
};


export default withRouter(MessagesSend);